import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB8qvS4Ic1YyBls5EGxjTtvBqMLkiIvOeo",
  authDomain: "movafit-app.firebaseapp.com",
  projectId: "movafit-app",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const login = async (email: string, password: string) => {
  await signInWithEmailAndPassword(auth, email, password);
};

export const logout = () => signOut(auth);
